import {ChangeDetectorRef, Component, ElementRef, NgZone, OnDestroy, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {Customer} from '../models/customer';
import {CustomerService} from '../services/customer.service';
import {ActivatedRoute, Router} from '@angular/router';
import {DatePipe, Location} from '@angular/common';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {NgbModal, NgbModalOptions} from '@ng-bootstrap/ng-bootstrap';
import {Alert, AlertType} from '../../shared/alert.model';
import {MessageService} from '../../shared/message.service';
import {getAlertMessage} from '../../shared/api-loaders';
import {ConfigurationService} from '../services/configuration.service';
import {Observable, Subject, Subscription} from 'rxjs';
import {MessageType} from '../../shared/messageType';
import {ClaimsService} from '../../shared/claims.service';
import {Configuration} from '../models/configuration';
import {SecurityService} from '../../shared/security.service';
import { ActivateDeactivateConfirmationDialogComponent } from '../activate-deactivate-confirmation-dialog/activate-deactivate-confirmation-dialog.component';
import {ModalService} from '../../shared/modal.service';


@Component({
    selector: 're-customer-feature-customer-detail',
    templateUrl: './customer-detail.component.html',
    styleUrls: ['./customer-detail.component.scss'],
    standalone: false
})
export class CustomerDetailComponent implements OnInit, OnDestroy {
  loading: boolean;
  newConfigurations: Configuration[] = [];
  dataTable: DataTables.Api;
  id: number;
  customer = new Customer();
  isReadOnlyUser: boolean;
  customers: Customer[] = [];
  accountIdExists: boolean;
  accountIdErrorMessage: string;
  @ViewChild('modalContent') templateRef: TemplateRef<any>;

  private _success = new Subject<string>();
  successAlert: Alert;
  alert: Alert;
  waiting: boolean;

  showMessage = false;
  hasGlobalError = false;
  targetUserName: string;
  editProfile: boolean;
  temporaryPassword: string;
  modalReference: any;
  guidSyncLoading=false;

  customerDetailForm: UntypedFormGroup = this.fb.group({
    id: [''],
    accountName: ['', Validators.required],
    accountId: ['', Validators.required],
    createdBy: [''],
    createdDate: [''],
    modifiedBy: [''],
    modifiedDate: [''],
    guid:['']
  });
  messageSubscription: Subscription;

  public configurations = [];
  public customerId: number;
  username: any;

  constructor(
    private route: ActivatedRoute,
    private customerService: CustomerService,
    private location: Location,
    private cdr: ChangeDetectorRef,
    private fb: UntypedFormBuilder,
    private modalService: NgbModal,
    private modalService2: ModalService,
    private configService: ConfigurationService,
    private messageService: MessageService,
    private claimService: ClaimsService,
    private router: Router,
    private datepipe: DatePipe,
    private ngZone: NgZone,
    private securityService: SecurityService
  ) {
    this.messageSubscription = this.messageService.get().subscribe(message => {
      if (message.type == MessageType.CustomerCreated) {
        this.alert = {type: AlertType.SUCCESS, message: `Customer ${message.data} has been created successfully`};
      }
      this.clearAlerts();
    })


    this.customerId = +this.route.snapshot.paramMap.get('id');
    if (!this.customerId) {
      this.editProfileClicked();
    }
  }

  ngOnDestroy(): void {
    this._success.unsubscribe();
    this.messageSubscription.unsubscribe();
    delete window["currentComponent"];
   // this.dataTable.destroy();

  }

  async ngOnInit() {
    window['currentComponent'] = this;
    this.isReadOnlyUser = await this.securityService.isThisReadOnlyUser();
    this.username = this.claimService.getPreferredName();
    this.getCustomer();
    if (this.customerId) {
      this.populateDataTable();
    }

  }


  // TODO refactor this to use: pipe/tap/map so each value does not have to be mapped.
  refreshForm(customer): void {
    this.loading = true;
    this.customerDetailForm.patchValue({
      id: customer.id,
      accountId: customer.accountId,
      accountName: customer.accountName,
      createdBy: customer.createdBy,
      createdDate: this.datepipe.transform(customer.createdDate, 'medium'),
      modifiedBy: customer.modifiedBy,
      modifiedDate: this.datepipe.transform(customer.modifiedDate, 'medium'),
      guid: customer.guid
    });


    this.customer = customer;
    this.configService.getConfigurationsByCustId(this.customerId).subscribe(data => {
      this.loading = false;
      this.configurations = data;
      this.dataTable.clear();
      this.dataTable.rows.add(this.configurations);
      this.dataTable.draw();
    });
  }

  goBack(): void {
    this.location.back();
    //  if (this.customerId)
    //    this.router.navigate(["../.."], { relativeTo: this.route });
    // else
    //    this.router.navigate([".."], { relativeTo: this.route  });
  }

  clearAlerts() {

    this.hasGlobalError = false;
    setTimeout(() => {
      this.showMessage = false;
      this.alert = null;
    }, 5000);
  }

  editProfileClicked() {
    this.editProfile = true;
    this.customerService.getCustomersByStack()
      .subscribe(customers => {
          this.customers = customers;
        },
        error => {
          this.alert = getAlertMessage(error);
        });
  }

  resetFlags() {

    this.editProfile = false;
    this.accountIdExists=false;
    this.getCustomer();
  }

  public daysFromToday(date): number {
    return 10;
  }

  getCustomer(): void {
    if (this.customerId) {
      this.customerService.getCustomer(this.customerId).subscribe(customer => this.refreshForm(customer));
    }
  }


  cancel() {
    if (this.customerId) {
      this.resetFlags();
    } else {
      this.goBack();
    }
  }

  // TODO: Make use of the functions available in user-list component with component to component interaction to avoid code duplication
  updateCustomer(): void {
    this.accountIdExists=false;
    const cust = new Customer(this.customerDetailForm.value);

    let obs: Observable<Customer>;

    if (this.customers.some(customer => (customer.accountId.toLowerCase() === cust.accountId.toLowerCase() &&
    customer.id !== cust.id))) {
      this.accountIdExists = true;
      this.accountIdErrorMessage = "Account ID already exists and cannot be re-added.";
    } else {
      this.accountIdErrorMessage="";
      this.accountIdExists=false;
    }
    if(!this.accountIdExists){
      if (this.customerId) {
        this.loading=true;
        delete cust.modifiedBy;
        delete cust.modifiedDate;

        cust.modifiedBy = this.username;
        obs = this.customerService.updateCustomer(this.customerId, cust);
        this.loading=false;
      } else {
        delete cust.createdDate;
        cust.createdBy = this.username;

        obs = this.customerService.addCustomer(cust);
      }

      obs.subscribe(
        customer => {
          // If customer was updated successfully, id must have some value.

          if (customer.id != null) {
            if (this.customerId) {
              this.resetFlags();
            } else {
              this.router.navigate(['../detail', customer.id], {relativeTo: this.route, replaceUrl: true}).then(status => {
                if (status) {
                  this.messageService.send({type: MessageType.CustomerCreated, data: cust.accountName});
                }
              });

            }
          }
        },
        err => {
          this.alert = getAlertMessage(err);
        }
      );
    }
  }


  navigateToRoute(url: string) {
    this.ngZone.run(() => {
      this.router.navigateByUrl(url);
    })
  }

  deleteCustomer(): void {
    this.customerService
      .deleteCustomer(this.customerId)
      .subscribe(
        res => {
          if (true) {
            this.resetFlags();
            this.showMessage = true;
            this.clearAlerts();
          }
        },
        err => {
          this.alert = getAlertMessage(err);
        }
      );
    this.goBack();
  }

  populateDataTable() {
    this.dataTable = $('#customerConfigurationList').DataTable({
      destroy: true,
      ordering: true,
      searching: false,
      paging: false,
      info: false,
      serverSide: false,
      autoWidth: false,
      language : {
        'zeroRecords': ' '
      },
      columns: [

        {
          title: 'ID', width: "15%", render: (data: any, type: any, c: Configuration) => {
            if(c.isDefault.toLowerCase()=='true'){
                return `${c.id} <i class="fa-regular fa-asterisk neo-success-3 small align-text-top"></i>`;
              } else {
              return `${c.id}`;
            }
            return `${c.id}`;
          }
        },
        {
          title: 'Configuration Name', render: (data: any, type: any, c: Configuration) => {
            return `<a href='javascript:currentComponent.navigateToRoute("/ect/configurations/detail/${c.id}")'>${c.configName}</a>`;
          }
        },
        {
          title: 'Status', render: (data: any, type: any, c: Configuration) => {
            let statusBadge = this.getStatusBadge(c);
            let html = ``;
            if (c.isActive==true) {
              html += `<span class="${statusBadge}"><span class="m-lg-2">Active</span></span>`;
            }
            else {
              html += `<span class="${statusBadge}"><span class="m-lg-2">Deactivated</span></span>`;
            }

            return html;
          }
        },
        {
          title: 'Actions', className: 'actionsCell',render: (data: any, type: any, c: Configuration) => {
            let html = ``;
            if (!this.isReadOnlyUser){
              if(c.isActive==true){
                html  = `<a href="javascript:" onclick="currentComponent.showActivateDeactivateConfirmationWindow(${c.id},'Deactivate')">Deactivate</a>`;
              } else{
                html  = `<a href="javascript:" onclick="currentComponent.showActivateDeactivateConfirmationWindow(${c.id},'Activate')">Activate</a>`;
              }
              return html;
            } else {
              if(c.isActive==true){
                html  = `<a href="javascript:" disabled="true">Deactivate</a>`;
              } else{
                html  = `<a href="javascript:" disabled="true">Activate</a>`;
              }
              return html;}

          }
        },
        {
          title: 'GUID', width: "20%", render: (data: any, type: any, c: Configuration) => {
            return c.guid ? `${c.guid}` : '';
          }
        },
        {
          title: 'Created Date', render: (data: Date, type: any, c: Configuration) => {
            return this.datepipe.transform(c.createdDate, 'medium');
            // return c.createdDate;
          }
        },
      ],

      columnDefs: [

        { targets: 1, type: 'date' }

      ],
    });

  }

  oktaConfigurationCall() {
    this.loading = true;
    if(this.customer) {
      const crmId = this.customer.accountId.toString();
      this.customerService.getCustomerOktaDetails(crmId).subscribe({
        next: (res) => {
          this.loading = false;
          this.goToConfigurePage(false);
        },
        error: (error) => {
          this.loading = false;
          if(error.error.code === 404) {
            this.openModal();
          }
        }
      })
    }
  }

  openModal() {
    const options: NgbModalOptions = { size: 'lg' };
    this.modalService.open(this.templateRef, options);
  }

  goToConfigurePage(editable: boolean) {
    this.router.navigate(['/ect/customers/detail/oktaConfiguration', this.customer.accountName, this.customer.accountId, editable]);
  }

  getStatusBadge(c: Configuration): string {
    if (c.isActive === true)
      return 'badge badge-success';

    if (c.isActive === false)
      return 'badge badge-default';

    return '';
  }

  async activateDeactivateConfiguration(id: string, status: string) {
    this.showSpinner();
    let c= await this.configService.getConfiguration(Number(id)).toPromise();
    let obs$: Observable<Configuration> = null;
    let actionText = "";
    if (status == 'Activate') {
      c.isActive=true;
      obs$ = this.configService.updateConfiguration(Number(id),c);
      actionText = "Activated";
    }
    if (status == 'Deactivate') {
      c.isActive=false;
      obs$ = this.configService.updateConfiguration(Number(id),c);
      actionText = "Deactivated";
    }
    this.messageService.clearAlert();

    if (obs$ != null) {
      obs$.subscribe(() => {
        this.messageService.sendSuccess(`Configuration ${id} was ${actionText} successfully.`);
        this.configService.getConfigurationsByCustId(this.customerId).subscribe(data => {
          this.loading = false;
          this.configurations = data;
          this.dataTable.clear();
          this.dataTable.rows.add(this.configurations);
          this.dataTable.draw();
        });
        this.hideSpinner();
      }, error => {
        this.hideSpinner();
        this.messageService.sendError(getAlertMessage(error).message);
      });
    }
  }

  private showSpinner() {
    this.messageService.send(MessageType.ProcessingOn);
  }

  private hideSpinner() {
    this.messageService.send(MessageType.ProcessingOff);
  }

  async showActivateDeactivateConfirmationWindow(id,statusForConfirmation) {
    //this.loading = true;
    var modal = this.modalService2.create<ActivateDeactivateConfirmationDialogComponent>(ActivateDeactivateConfirmationDialogComponent);

    let status2: { statusForConfirmation: string }={
      statusForConfirmation:statusForConfirmation
    };
    modal.component.statusForConfirmation=status2;

    var result = await modal.modalRef.result;

    if (result) {
      await this.activateDeactivateConfiguration(id,statusForConfirmation);
    } else {
      this.loading = false;
    }
  }

  accountIdChanged(){
    this.accountIdErrorMessage="";
    this.accountIdExists=false;
  }

  async customerGuidSync() {
    this.guidSyncLoading=true;
    this.loading=true;
    try {
      await this.customerService.customerGuidSync(this.customer.accountId).toPromise();
      this.successAlert = {
        message: `GUID Sync has been completed successfully for CRM ID: ${this.customer.accountId}`,
        type: AlertType.SUCCESS
      };
      this.resetFlags();
      this.guidSyncLoading=false;
    } catch (e) {
      this.alert = getAlertMessage(e);
      this.loading=false;
      this.guidSyncLoading=false;
    }
  }

  getNgStyleColorBasedOnStatus(status) {
    if (status === 'LOADING') {
      return '#141888';
    } else if (status === 'UP') {
      return '#26882B';
    } else if (status === 'DOWN') {
      return '#ff0000';
    } else {
      return '#1e2aff';
    }
  }
}
